import { Shield, Lock, Eye, Server, CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const CompactSecurityFooter = () => {
  const { t, language } = useLanguage();
  const badges = t('security.compact.badges') || [];

  const badgeIcons = [Lock, CheckCircle2, Lock, Eye, Server, Shield];

  return (
    <section className="py-8 bg-slate-100 border-t border-slate-200" data-testid="compact-security-footer">
      <div className="container-max px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left: title + badges */}
          <div className="flex flex-col items-center md:items-start gap-3 flex-1">
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-[#0077FF]" />
              <span className="text-sm font-bold text-slate-800" data-testid="compact-security-title">
                {t('security.compact.title')}
              </span>
            </div>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-2" data-testid="compact-security-badges">
              {badges.map((badge, i) => {
                const Icon = badgeIcons[i] || Shield;
                return (
                  <span
                    key={i}
                    className="inline-flex items-center gap-1.5 bg-white text-slate-600 text-[10px] font-medium px-2.5 py-1.5 rounded-full border border-slate-200"
                    data-testid={`security-badge-${i}`}
                  >
                    <Icon className="w-3 h-3 text-[#0077FF] flex-shrink-0" />
                    {badge}
                  </span>
                );
              })}
            </div>
          </div>

          {/* Right: CTA link */}
          <Link
            to={`/${language}/security`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#0077FF] hover:text-[#0066DD] transition-colors whitespace-nowrap group"
            data-testid="compact-security-link"
          >
            {t('security.compact.viewFull')}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CompactSecurityFooter;
